import { FORMAT_BULLETED_LIST_MENU_ITEM, FORMAT_NESTED_MENU_RANK, FORMAT_NUMBERED_LIST_MENU_ITEM } from '@atlaskit/editor-common/block-menu';
import { createBulletedListBlockMenuItem } from './BulletedListBlockMenuItem';
import { createNumberedListBlockMenuItem } from './NumberedListBlockMenuItem';
export var getListComponents = function getListComponents(api) {
  return [{
    type: 'block-menu-item',
    key: FORMAT_BULLETED_LIST_MENU_ITEM.key,
    parent: {
      type: 'block-menu-section',
      key: 'nested-menu-format-section-primary',
      rank: FORMAT_NESTED_MENU_RANK[FORMAT_BULLETED_LIST_MENU_ITEM.key]
    },
    component: createBulletedListBlockMenuItem({
      api: api
    })
  }, {
    type: 'block-menu-item',
    key: FORMAT_NUMBERED_LIST_MENU_ITEM.key,
    parent: {
      type: 'block-menu-section',
      key: 'nested-menu-format-section-primary',
      rank: FORMAT_NESTED_MENU_RANK[FORMAT_NUMBERED_LIST_MENU_ITEM.key]
    },
    component: createNumberedListBlockMenuItem({
      api: api
    })
  }];
};